/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skipLinkFocusFix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import Tabs from './site/tabs';
import FollowBtn from './site/followBtn';
import EmployeeStats from './site/employeeStats';
import Accordion from './site/accordion';
import HeaderToggles from './site/headerToggles';
import PopupToggle from './site/popupToggle';
import CompanyReview from './site/companyReview';
import ReviewVotes from './site/reviewVotes';
import OwnerReviewResponse from './site/ownerReviewResponse';
import IdbHandler from './idb/idbHandler';
import SearchCompanies from './site/searchCompanies';
import Login from './site/login';
import Register from './site/register';
import Chat from './site/chat';
import ResetPassword from './site/resetPassword';
import UpdatePassword from './site/updatePassword';
import ChatSearch from './site/chatSearch';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	Tabs.init();
	FollowBtn.init();
	EmployeeStats.init();
	Accordion.init();
	HeaderToggles.init();
	PopupToggle.init();
	CompanyReview.init();
	ReviewVotes.init();
	OwnerReviewResponse.init();
	IdbHandler.init();
	SearchCompanies.init();
	Login.init();
	Register.init();
	Chat.init();
	ResetPassword.init();
	UpdatePassword.init();
	ChatSearch.init();
});
